var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Favourite = _interopRequireDefault(require("./Favourite"));

var _Basic = require("../../../elements/Basic");

var _PropsHelper = require("../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Favourites/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Favourites = function (_React$Component) {
  (0, _inherits2.default)(Favourites, _React$Component);

  var _super = _createSuper(Favourites);

  function Favourites() {
    (0, _classCallCheck2.default)(this, Favourites);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Favourites, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          favourites = _this$props.favourites,
          onRemove = _this$props.onRemove,
          showRemove = _this$props.showRemove;
      return _react.default.createElement(_Basic.ScrollView, {
        row: true,
        horizontal: true,
        showsHorizontalScrollIndicator: false,
        mb: 2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 18,
          columnNumber: 13
        }
      }, favourites && favourites.length ? favourites.map(function (item) {
        return _react.default.createElement(_Favourite.default, {
          key: item.id,
          icon: item.imageUrl,
          title: item.name || item.lastName,
          imageType: item.type,
          onRemove: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onRemove, item),
          showRemove: showRemove,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 21,
            columnNumber: 25
          }
        });
      }) : _react.default.createElement(_Basic.View, {
        height: 64,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 31,
          columnNumber: 21
        }
      }));
    }
  }]);
  return Favourites;
}(_react.default.Component);

Favourites.propTypes = {
  favourites: _propTypes.default.arrayOf(Object).isRequired,
  onRemove: _propTypes.default.func,
  showRemove: _propTypes.default.func
};
var _default = Favourites;
exports.default = _default;